import * as React from "react";
import {
  Container,
  Col,
  Row,
  Breadcrumb,
  BreadcrumbItem,
  Button
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { cs, enGB } from "date-fns/locale";
import { licenceAction, systemsAction } from "../../_actions";
import { LicenceLanguages } from "./LicenceLanguages";
import { bindActionCreators, compose } from "redux";
import { Loading } from "../Loading";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

import { LicencePrices } from ".";

class LicenceDetail extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      test: "",
      systemId: "",
      values: {
        licenceTypeMetas: {},
        prices: {}
      }
    };

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.systemId = this.systemId.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;
    const licenceId = match.params.id;
    this.props.load(licenceId);
    this.props.loadSystems();
  }

  getDate(datetime: string) {
    let date = {
      day: datetime.slice(8, 10),
      month: datetime.slice(5, 7),
      year: datetime.slice(0, 4)
    };
    return date.year + "-" + date.month + "-" + date.day;
  }

  getDateFromDate(datetime: any) {
    let date = {
      day: datetime.getDate(),
      month: datetime.getMonth() + 1,
      year: datetime.getFullYear()
    };

    date.month =
      date.month.toString().length == 1 ? "0" + date.month : date.month;
    date.day = date.day.toString().length == 1 ? "0" + date.day : date.day;
    return date.year + "-" + date.month + "-" + date.day;
  }

  renderSystems(systems: any) {
    return systems.map((data: any) => {
      return (
        <option key={data.id} value={data.id}>
          {data.name}
        </option>
      );
    });
  }

  onAvailableFromChange(date: any) {
    this.setState({ avaiableFrom: date });
  }

  onAvailableToChange(date: any) {
    this.setState({ avaiableTo: date });
  }

  onPriceChange(price: any) {
    this.setState({ price });
  }

  onLanguageChange(languages: any) {
    this.setState({ languages });
  }

  handleValidSubmit(event: any, values: any) {
    const { licence } = this.props;
    this.state.systemId == "" &&
      this.setState({ systemId: this.props.licence.systemInfoId });
    this.setState({
      values: {
        id: values.id,
        name: values.name,
        iconName: values.iconName,
        avaiableFrom: this.state.avaiableFrom
          ? this.state.avaiableFrom
          : licence.data.avaiableFrom,
        avaiableTo: this.state.avaiableTo
          ? this.state.avaiableTo
          : licence.data.avaiableTo,
        hasPeriod: values.numberOfMonths != "0",
        numberOfMonths: values.numberOfMonths,
        licenceIdentification: values.licenceIdentification,
        systemInfoId: values.systemInfoId,
        licenceTypeMetas: this.state.languages,
        prices: this.state.price
      }
    });
    console.log(this.state.values);
    this.props.edit(this.state.values);
    window.scrollTo(0, 0);
  }

  systemId(event: any) {
    this.setState({ systemId: event.target.value });
  }

  render() {
    const { licence, loading, systems, t } = this.props;
    const i18nextLng = localStorage.getItem("i18nextLng");
    const locales = i18nextLng == "cs" ? cs : enGB;

    if (
      loading ||
      licence.data == [] ||
      !licence.data.licenceTypeMetas ||
      !systems
    ) {
      return <Loading />;
    }

    if (licence.data.licenceTypeMetas) {
      licence.data.licenceTypeMetas.sort(function(a: any, b: any) {
        if (a.language < b.language) {
          return -1;
        }
        if (a.language > b.language) {
          return 1;
        }
        return 0;
      });

      licence.data.prices.sort(function(a: any, b: any) {
        if (a.currency < b.currency) {
          return -1;
        }
        if (a.currency > b.currency) {
          return 1;
        }
        return 0;
      });
      return (
        <Container>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/">Sypal</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/licence-list">{t("licence_list")}</Link>
            </BreadcrumbItem>
            <BreadcrumbItem active>{t("licence_detail")}</BreadcrumbItem>
          </Breadcrumb>
          <AvForm
            className="sypal-form"
            style={{ paddingBottom: "30px" }}
            onValidSubmit={this.handleValidSubmit}
            id="licence-form"
          >
            <AvField
              name="name"
              label={t("name")}
              value={licence.data.name}
              required
            />
            <AvField
              type="select"
              name="systemInfoId"
              label={t("system")}
              onChange={this.systemId}
              value={licence.data.systemInfoId}
            >
              {this.renderSystems(systems.data)}
            </AvField>
            <Row>
              <Col md="6">
                <AvField
                  name="licenceIdentification"
                  label={t("id")}
                  value={licence.data.licenceIdentification}
                />
              </Col>
              <Col md="6">
                <AvField
                  name="iconName"
                  label={t("icon_name")}
                  value={licence.data.iconName}
                />
              </Col>
            </Row>

            <div style={{ display: "none" }}>
              <AvField name="id" value={licence.data.id} />
            </div>

            <Row className="form-group">
              <Col md="6" className="mb-3 mb-sm-3 mb-md-0 mb-lg-0 mb-xl-0">
                <Row className="sypal-input m-0">
                  <span>{t("available_from")}</span>
                </Row>
                <DatePicker
                  selected={
                    this.state.avaiableFrom
                      ? new Date(this.state.avaiableFrom)
                      : new Date(licence.data.avaiableFrom)
                  }
                  onChange={date =>
                    this.onAvailableFromChange(this.getDateFromDate(date))
                  }
                  dateFormat="PP"
                  label={t("available_from")}
                  locale={locales}
                  className="w-100 is-untouched is-pristine av-valid form-control"
                />
              </Col>
              <Col md="6">
                <Row className="sypal-input m-0">
                  <span>{t("available_to")}</span>
                </Row>
                <DatePicker
                  selected={
                    this.state.avaiableTo
                      ? new Date(this.state.avaiableTo)
                      : new Date(licence.data.avaiableTo)
                  }
                  onChange={date =>
                    this.onAvailableToChange(this.getDateFromDate(date))
                  }
                  dateFormat="PP"
                  label={t("available_to")}
                  locale={locales}
                  className="w-100 is-untouched is-pristine av-valid form-control"
                />
              </Col>
            </Row>
            <AvField
              type="select"
              name="numberOfMonths"
              label={t("duration")}
              value={licence.data.numberOfMonths}
            >
              <option value="1">1 {t("mesic")}</option>
              <option value="3">3 {t("mesice")}</option>
              <option value="6">6 {t("mesicu")}</option>
              <option value="12">1 {t("year")}</option>
              <option value="0">{t("lifespan")}</option>
            </AvField>
          </AvForm>
          <LicenceLanguages
            languages={licence.data.licenceTypeMetas}
            onLanguageChange={(languages: any) =>
              this.onLanguageChange(languages)
            }
          />
          <LicencePrices
            prices={licence.data.prices}
            onPriceChange={(prices: any) => this.onPriceChange(prices)}
          />
          <Row style={{ justifyContent: "center", padding: "30px 0" }}>
            <Col style={{ textAlign: "center" }} sm="12" md="4">
              <Button
                color="success"
                type="submit"
                form="licence-form"
                className="w-100"
              >
                {t("save")}
              </Button>
            </Col>
          </Row>
        </Container>
      );
    }
  }
}

const mapStateToProps = (state: any) => {
  return {
    licence: state.licence,
    systems: state.systems
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      load: licenceAction.loadLicence,
      loadSystems: systemsAction.loadSystems,
      edit: licenceAction.editLicence
    },
    dispatch
  );
};

const LicenceDetailComponent = compose(
  withTranslation("licences"),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LicenceDetail);

export { LicenceDetailComponent as LicenceDetail };
